import React, { createContext, useContext, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import StatisticsRepository from "../../repository/AdminDashboard/Homepage/statistics-repository";
import NewOrderRepository from "../../repository/AdminDashboard/Homepage/newOrder-repository";
import NewMassageRepository from "../../repository/AdminDashboard/Homepage/newMassage-Repository";

// Create a new context
const StateContext = createContext();

// Define the initial state
const initialState = {
  currentStatic: 1,
  statistic: [],
  neworder: [],
  massage: [],
};

// Create the context provider component
const HomeContext = ({ children }) => {
  const [satatistic, setsatatistic] = useState(initialState.statistic);
  //todo mehdi -> Comment
  const [currentStatstic, setCurrent] = useState(initialState.currentStatic);
  const [newOrder, setnewOrder] = useState(initialState.neworder);
  const [massage, setmassage] = useState(initialState.massage);
  const [isPageLoaded, setisPageLoaded] = useState(false);
  const [countNewOrder, setcountall] = useState();
  const [countNewMassage, setcountNewMassage] = useState();
  const [id, setid] = useState("");
  const [showDeleteModal, setshowDeleteModal] = useState(false);
  const [name, setname] = useState("");
  const [statisticLoaded, setstatisticLoaded] = useState(false);

  //  fetching and handling the statistics data
  const getdata = async (num = 1) => {
    const { statistic, code, massage } = await StatisticsRepository.getStatistics(num);

    const satatistic_data = statistic;
    
    // const newOrder_data = await NewOrderRepository.getnewOrder();
    // const newMassage_data = await NewMassageRepository.getmassage();
    // setmassage(newMassage_data.massageList);
    // setcountNewMassage(newMassage_data.countAll)

    // Handle the response based on the code
    if (code == 1) {
      // Update the statistic state with the fetched data
      setsatatistic(satatistic_data);
    } else if (code == 0) {
      // Display an error toast if the code is 0
      return toast.error(massage, {
        className: "text-12 text-dark-blue-200",
      });

    }
    // if (newOrder_data.codeOrder == 1) {
    // setnewOrder(newOrder_data.orderList);
    // setcountall(newOrder_data.countAll);
    // } else if (newOrder_data.codeOrder == 0) {
    //   return toast.error(newOrder_data.massageorder, {
    //     className: "text-12 text-dark-blue-200",
    //   });
    // }
    setisPageLoaded(true);
  };

  // This is used in NewOrder which has been commented
  const onView = () => {
   };

  // delete NewOrder item which has been commented
  const getdeleteData = async (id) => {

    const newOrder_data = await NewOrderRepository.deleteNewOrder(id);

    if (newOrder_data.code == 1) {

      const newList = newOrder.filter((item) => {
        return item.id !== id;
      });

      setnewOrder(newList);
      toast.success(newOrder_data.massage, {
        className: "text-12 text-dark-blue-200",
      });
    } else if (newOrder_data.code == 0) {
      return (
        newOrder,
        toast.error(newOrder_data.massage, {
          className: "text-12 text-dark-blue-200",
        })
      );
    }
  };
  
  //show remove modal for NewOrder's item which has been commented
  const onDelete = (event) => {
    const id = event.currentTarget.getAttribute("data-attr");
    setname(newOrder[id].number_orders);
    setid(id);
    setshowDeleteModal(true);
  };

  //close remove modal for NewOrder's item which has been commented
  const closeDeleteModal = () => {
    setshowDeleteModal(false);
  };

//  remove NewOrder's item which has been commented
  const RemoveItem = async () => {
    await getdeleteData(id);
    setshowDeleteModal(false);
  };

   // This is used in NewMessage which has been commented
  const onMassage = () => {
  };


  // change statistics timezone.
  const changeStatistic = async (event) => {
    setstatisticLoaded(true);
    if (event.length > 0) {
        //this For Second Filter That been Deleted
      setCurrent(event[0].value);

      await getdata(event[0].value);

      setstatisticLoaded(false);
    }
  };

  // Return the context provider with the state and functions in the value
  return (
    <StateContext.Provider
      value={{
        satatistic,
        getdata,
        newOrder,
        isPageLoaded,
        onDelete,
        onView,
        onMassage,
        massage,
        changeStatistic,
        countNewOrder,
        countNewMassage,
        showDeleteModal,
        closeDeleteModal,
        RemoveItem,
        name,
        statisticLoaded,
      }}>
      {children}
    </StateContext.Provider>
  );
};

// Create a custom hook for using the context
function useStateContext() {
  return React.useContext(StateContext);
}

// Export the custom hook and the context provider component
export { useStateContext };
export default HomeContext;
